import { EVENT_TYPES } from '../types';
export const getEmptyListenerMap = () => EVENT_TYPES.reduce((result, type) => {
    return {
        ...result,
        [type]: new Set()
    };
}, {});
//# sourceMappingURL=getEmptyListenerMap.js.map